module.exports = __webpack_public_path__ + "static/media/amit_headshot.e90b75b4.png";